import React, { useEffect, useMemo, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { DropdownItem, DropdownMenu, LinkText, Wrapper } from "./styled";

import { CopyIcon, ArrowSquareOutIcon } from "@phosphor-icons/react";
import Icon from "components/Icon/Icon";
import CommonTooltip from "components/Tooltip/index";

const SocialLinkDropdown = ({ value, type }) => {
  const [open, setOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);

  const cleanedData = useMemo(() => {
    if (!value || value.trim() === "") return null;

    let cleaned = value.trim();

    if (type === "text") {
      return {
        label: cleaned,
        url: cleaned, // for copy
        isText: true
      };
    }

    switch (type) {
      case "instagram": {
        cleaned = cleaned
          .replace(/^@/, "")
          .replace(/^https?:\/\/(www\.)?instagram\.com\//, "")
          .replace(/\/$/, "");

        const fullUrl = `https://www.instagram.com/${cleaned}`;

        return {
          label: fullUrl,
          url: fullUrl
        };
      }

      case "linkedin": {
        cleaned = cleaned.replace(/^https?:\/\/(www\.)?linkedin\.com\//, "");

        const linkedUrl = `https://www.linkedin.com/${cleaned}`;

        return {
          label: linkedUrl,
          url: linkedUrl
        };
      }

      case "twitter": {
        cleaned = cleaned
          .replace(/^@/, "")
          .replace(/^https?:\/\/(www\.)?(twitter\.com|x\.com)\//, "")
          .replace(/\/$/, "");

        const twitterUrl = `https://x.com/${cleaned}`;

        return {
          label: twitterUrl,
          url: twitterUrl
        };
      }

      default: {
        if (!/^https?:\/\//.test(cleaned)) {
          cleaned = `https://${cleaned}`;
        }

        return {
          label: cleaned,
          url: cleaned
        };
      }
    }
  }, [value, type]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!cleanedData) return <span>-</span>;

  const handleToggle = (e) => {
    e.stopPropagation();

    if (!open && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();

      setPosition({
        top: rect.bottom + window.scrollY + 6,
        left: rect.left + window.scrollX
      });
    }

    setOpen((prev) => !prev);
  };

  const handleCopy = async (e) => {
    e.stopPropagation();
    await navigator.clipboard.writeText(cleanedData.url);
    setOpen(false);
  };

  const handleOpen = (e) => {
    e.stopPropagation();
    window.open(cleanedData.url, "_blank");
    setOpen(false);
  };

  return (
    <>
      <Wrapper ref={wrapperRef}>
        {cleanedData.isText ? (
          // No tooltip for text
          <LinkText onClick={handleToggle}>{cleanedData.label}</LinkText>
        ) : (
          // Tooltip for links
          <CommonTooltip
            theme="dark"
            tooltipContent={cleanedData.label}
            WrapperClass="link-dropdown"
          >
            <LinkText onClick={handleToggle}>{cleanedData.label}</LinkText>
          </CommonTooltip>
        )}
      </Wrapper>

      {open &&
        ReactDOM.createPortal(
          <DropdownMenu
            ref={dropdownRef}
            style={{
              position: "absolute",
              top: position.top,
              left: position.left
            }}
          >
            <DropdownItem onClick={handleCopy}>
              <Icon component={CopyIcon} size={14} />
              Copy {cleanedData.isText ? "Text" : "Link"}
            </DropdownItem>

            {/* Hide for text */}
            {!cleanedData.isText && (
              <DropdownItem onClick={handleOpen}>
                <Icon component={ArrowSquareOutIcon} size={14} />
                Open Link
              </DropdownItem>
            )}
          </DropdownMenu>,
          document.body
        )}
    </>
  );
};

export default SocialLinkDropdown;
